export default "__VITE_ASSET__BZkqh8gu__"